import useSWR from 'swr';
import { salesOfficeAreaId } from '../../constants';
import { IOnlineTourPriceResult } from '../../utils/types';
import { usePublicFetcher } from './use-fetcher';

export function useTourPrices({ tourId }: { tourId: number }) {
  const fetcher = usePublicFetcher();
  const { data, error, isLoading } = useSWR<IOnlineTourPriceResult[]>(
    `/api/online/tours/${tourId}/prices?salesOfficeAreaId=${salesOfficeAreaId}`,
    fetcher,
  );

  return {
    data,
    error,
    isLoading,
  };
}
